import { createSelector } from '@ngrx/store';
import { Params } from '@angular/router';
import isEmpty from 'lodash.isempty';
import { FILTER_RANGE_KEYS } from '../../constants';

import * as fromRouter from '~core/store';
import { Category } from '~app/modules/generic/models';
import * as fromFilters from './filters.selectors';
import { NUMBER_0, NUMBER_1 } from '~shared/constants';

export const getFilterParams = createSelector(fromRouter.getQueryParams, (params: Params) => params && params.filter);

export const getPriceFilters = createSelector(getFilterParams, (params: Params) =>
  params && params.price ? params.price : { from: null, to: null }
);

export const getOptionRangesFilters = createSelector(getFilterParams, (params: Params) =>
  params && params.options_ranges
    ? params.options_ranges
    : {
        [FILTER_RANGE_KEYS.WIDTH]: { from: null, to: null },
        [FILTER_RANGE_KEYS.HEIGHT]: { from: null, to: null },
        [FILTER_RANGE_KEYS.LENGTH]: { from: null, to: null },
        [FILTER_RANGE_KEYS.DIAMETER]: { from: null, to: null },
      }
);

export const getAttributeFilters = createSelector(getFilterParams, (params: Params) =>
  params && params.options && !isEmpty(params.options) ? params.options : {}
);

export const getCategoriesFilters = createSelector(getFilterParams, (params: Params) =>
  params && params.categories ? params.categories : []
);

export const getBlackDealFilter = createSelector(getFilterParams, (filter) => filter && filter.blackFriday);

export const getPromotionFilter = createSelector(getFilterParams, (filter) => filter && filter.promotion);

export const getVolumePriceFilter = createSelector(getFilterParams, (filter) => filter && filter.volumePrices);

export const getRebuyGuaranteeFilter = createSelector(getFilterParams, (filter) => {
  return filter?.options?.characteristics?.find((characteristicId: string) => characteristicId === 'int_rbg');
});

export const getFiltersCount = createSelector(
  getAttributeFilters,
  getPriceFilters,
  getOptionRangesFilters,
  getCategoriesFilters,
  getVolumePriceFilter,
  getPromotionFilter,
  getBlackDealFilter,
  (
    attributeFilters,
    priceFilters,
    optionRangesFilters,
    categoriesFilters,
    volumePriceTag,
    promotionTag,
    blackDealTag
  ) => {
    const attributeFiltersLength: number =
      (Object.keys(attributeFilters).length > 0 ? [].concat(...Object.values(attributeFilters)) : [])?.length || 0;
    const priceFiltersLength: number = priceFilters?.from || priceFilters?.to ? 1 : 0;
    const optionRangesFiltersLenght = Object.values(optionRangesFilters)?.filter(({ from, to }) => from && to)?.length;

    return (
      attributeFiltersLength +
      priceFiltersLength +
      optionRangesFiltersLenght +
      categoriesFilters?.length +
      (volumePriceTag ? NUMBER_1 : NUMBER_0) +
      (promotionTag ? NUMBER_1 : NUMBER_0) +
      (blackDealTag ? NUMBER_1 : NUMBER_0)
    );
  }
);

export const getSelectedChildCategory = createSelector(
  fromFilters.getCategories,
  getCategoriesFilters,
  (resultsCategories: Category[], filteredCategories: string[]) => {
    return {
      resultsCategories,
      filteredCategories,
    };
  }
);

export interface SelectChildCategoryStorePayload {
  resultsCategories: Category[];
  filteredCategories: string[];
}
